document.addEventListener('DOMContentLoaded', () => {
  const nav = document.querySelector('[data-custom-breadcrumb]');
  if (!nav) return;

  const list = nav.querySelector('.custom-breadcrumb__list');
  if (!list) return;

  const currentItem = list.querySelector('.custom-breadcrumb__item--current');
  if (!currentItem) return;

  let referrer;
  try {
    referrer = new URL(document.referrer);
  } catch (error) {
    return;
  }

  if (referrer.origin !== window.location.origin) return;

  const match = referrer.pathname.match(/\/collections\/([a-zA-Z0-9_-]+)\/?$/);
  if (!match) return;

  const handle = match[1];
  const root =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  fetch(`${root}collections/${handle}`)
    .then((response) => {
      if (!response.ok) throw new Error('Collection page fetch failed');
      return response.text();
    })
    .then((html) => {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const collectionCurrentItem = parsed.querySelector(
        '.custom-breadcrumb__item--current'
      );
      if (!collectionCurrentItem) return;

      const title = collectionCurrentItem.textContent.trim();
      if (!title) return;

      const item = document.createElement('li');
      item.className = 'custom-breadcrumb__item';

      const link = document.createElement('a');
      link.href = `${root}collections/${handle}`;
      link.textContent = title;

      item.appendChild(link);
      list.insertBefore(item, currentItem);
    })
    .catch(() => {});
});
